import Auth from '../auth'
import RestClient from "../components/RestClient.vue"

export default class GoogleAuth implements Auth {
    name = 'google'
    client_id: string
    restClient: RestClient
    constructor(client_id: string, restClient: RestClient) {
        this.client_id = client_id
        this.restClient = restClient
    }
    signIn(redirect: string) {
        let redirect_uri = window.location.origin + '/authcb/google'
        this.restClient.request("POST", "/v1/sessions", {redirect_uri: redirect_uri, redirect: redirect}, (session: any) => {
            window.location.href = 'https://accounts.google.com/o/oauth2/v2/auth?' +
                'scope=openid%20profile%20email&' +
                'state=' + encodeURIComponent(session.id) + '&' +
                'redirect_uri=' + encodeURIComponent(redirect_uri) + '&' +
                'response_type=code&' +
                'client_id=' + this.client_id
        })
    }
    signOut() {
        let p = new Promise<void>((resolve) => {
            resolve()
        })
        return p
    }
}
